export default __webpack_public_path__ + "static/media/biodata-7.5d0d447a.png";